import React, { useState, useEffect } from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown, Loader2, AlertTriangle, X } from 'lucide-react';
import { getApiUrl } from '../../utils/api';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';

type OrderData = {
  date_activation: string;
  country: string;
  campaign: string;
  platform?: string;
  campaign_id?: string;
  campaign_original?: string;
  historic_coeff?: number | null;
  arppu: number;
  revenue_before_p1_purchase?: number | null;
  ltv: number;
  predicted_ltv: number;
  cpa_cost_per_action: number;
  cpu_cost_per_user: number;
  roi: number;
  revenue_activation_purchase?: number | null;
  predicted_roi: number;
  revenue_activation_count: number;
  revenue_activation_purchase_count: number | null;
  revenue_activation: number | null;
  revenue_p1: number | null;
  revenue_p1_count: number | null;
  revenue_p2: number | null;
  revenue_p2_count: number | null;
  revenue_p3: number | null;
  revenue_p3_count: number | null;
  revenue_p4: number | null;
  revenue_p4_count: number | null;
  revenue_p5: number | null;
  revenue_p5_count: number | null;
  revenue_p6: number | null;
  revenue_p6_count: number | null;
  revenue_p7: number | null;
  revenue_p7_count: number | null;
  revenue_p8: number | null;
  revenue_p8_count: number | null;
  revenue_p9: number | null;
  revenue_p9_count: number | null;
  revenue_p10: number | null;
  revenue_p10_count: number | null;
  revenue_p11: number | null;
  revenue_p11_count: number | null;
  revenue_p12: number | null;
  revenue_p12_count: number | null;
  // ИСПРАВЛЕНО: Добавляем периоды 13-24
  revenue_p13: number | null;
  revenue_p13_count: number | null;
  revenue_p14: number | null;
  revenue_p14_count: number | null;
  revenue_p15: number | null;
  revenue_p15_count: number | null;
  revenue_p16: number | null;
  revenue_p16_count: number | null;
  revenue_p17: number | null;
  revenue_p17_count: number | null;
  revenue_p18: number | null;
  revenue_p18_count: number | null;
  revenue_p19: number | null;
  revenue_p19_count: number | null;
  revenue_p20: number | null;
  revenue_p20_count: number | null;
  revenue_p21: number | null;
  revenue_p21_count: number | null;
  revenue_p22: number | null;
  revenue_p22_count: number | null;
  revenue_p23: number | null;
  revenue_p23_count: number | null;
  revenue_p24: number | null;
  revenue_p24_count: number | null;
  // ИСПРАВЛЕНО: Расширяем predicted до 24 периодов
  predicted_revenue_p1?: number | null;
  predicted_revenue_p2?: number | null;
  predicted_revenue_p3?: number | null;
  predicted_revenue_p4?: number | null;
  predicted_revenue_p5?: number | null;
  predicted_revenue_p6?: number | null;
  predicted_revenue_p7?: number | null;
  predicted_revenue_p8?: number | null;
  predicted_revenue_p9?: number | null;
  predicted_revenue_p10?: number | null;
  predicted_revenue_p11?: number | null;
  predicted_revenue_p12?: number | null;
  predicted_revenue_p13?: number | null;
  predicted_revenue_p14?: number | null;
  predicted_revenue_p15?: number | null;
  predicted_revenue_p16?: number | null;
  predicted_revenue_p17?: number | null;
  predicted_revenue_p18?: number | null;
  predicted_revenue_p19?: number | null;
  predicted_revenue_p20?: number | null;
  predicted_revenue_p21?: number | null;
  predicted_revenue_p22?: number | null;
  predicted_revenue_p23?: number | null;
  predicted_revenue_p24?: number | null;
  // ИСПРАВЛЕНО: Расширяем early_predicted до 24 периодов
  early_predicted_revenue_p1?: number | null;
  early_predicted_revenue_p2?: number | null;
  early_predicted_revenue_p3?: number | null;
  early_predicted_revenue_p4?: number | null;
  early_predicted_revenue_p5?: number | null;
  early_predicted_revenue_p6?: number | null;
  early_predicted_revenue_p7?: number | null;
  early_predicted_revenue_p8?: number | null;
  early_predicted_revenue_p9?: number | null;
  early_predicted_revenue_p10?: number | null;
  early_predicted_revenue_p11?: number | null;
  early_predicted_revenue_p12?: number | null;
  early_predicted_revenue_p13?: number | null;
  early_predicted_revenue_p14?: number | null;
  early_predicted_revenue_p15?: number | null;
  early_predicted_revenue_p16?: number | null;
  early_predicted_revenue_p17?: number | null;
  early_predicted_revenue_p18?: number | null;
  early_predicted_revenue_p19?: number | null;
  early_predicted_revenue_p20?: number | null;
  early_predicted_revenue_p21?: number | null;
  early_predicted_revenue_p22?: number | null;
  early_predicted_revenue_p23?: number | null;
  early_predicted_revenue_p24?: number | null;
  // ИСПРАВЛЕНО: Расширяем predicted_churn до 24 периодов
  predicted_churn_p1?: number | null;
  predicted_churn_p2?: number | null;
  predicted_churn_p3?: number | null;
  predicted_churn_p4?: number | null;
  predicted_churn_p5?: number | null;
  predicted_churn_p6?: number | null;
  predicted_churn_p7?: number | null;
  predicted_churn_p8?: number | null;
  predicted_churn_p9?: number | null;
  predicted_churn_p10?: number | null;
  predicted_churn_p11?: number | null;
  predicted_churn_p12?: number | null;
  predicted_churn_p13?: number | null;
  predicted_churn_p14?: number | null;
  predicted_churn_p15?: number | null;
  predicted_churn_p16?: number | null;
  predicted_churn_p17?: number | null;
  predicted_churn_p18?: number | null;
  predicted_churn_p19?: number | null;
  predicted_churn_p20?: number | null;
  predicted_churn_p21?: number | null;
  predicted_churn_p22?: number | null;
  predicted_churn_p23?: number | null;
  predicted_churn_p24?: number | null;
  count_unique_payers?: number | null;
  count_unique_payers_activation?: number | null;
  costs: number | null;
  total_revenue: number | null;
  total_predicted_revenue?: number | null;
  revenue_activation_original?: number | null;
};

type ChartPoint = {
  date: string;
  cost: number;
  revenue: number;
  roi: number;   // %
};

type GroupedOrderData = {
  [date: string]: {
    [country: string]: OrderData[];
  };
};

type AggregatedData = {
  [key: string]: OrderData;
};

type Anomaly = {
  campaign_id: string;
  campaign_name: string;
  country: string;
  anomaly_type: string;
  start_date: string;
  end_date: string;
  created_at: string;
  value: number;
  description: string;
  reasons: string[];
  recommendations: string[];
  severity: 'critical' | 'warning';
  details: any;
};

type TotalsComponentProps = {
  database: string;
  dateFrom: string;
  dateTo: string;
  selectedPlatforms: string[];
  selectedCountries?: string[];
  selectedCampaigns?: string[];
  showCountries: boolean;
  showCampaigns: boolean;
  showWithTax: boolean;
  viewMode: 'daily' | 'monthly';
  hideAllPeriods: boolean;
  showEarlyPredicted: boolean;
  vatRates: { [country: string]: number };
  distributeUnknowns?: boolean;
  distributeDirect?: boolean;
  onSelectCampaign?: (campaignName: string) => void;
};

type SortConfig = {
  key: string;
  direction: 'asc' | 'desc' | 'none';
};

const TotalsComponent: React.FC<TotalsComponentProps> = ({
  database,
  dateFrom,
  dateTo,
  selectedCountries = [],
  selectedCampaigns = [],
  selectedPlatforms,
  showCountries,
  showCampaigns,
  showWithTax,
  viewMode,
  hideAllPeriods,
  showEarlyPredicted,
  vatRates,
  distributeUnknowns = false,
  distributeDirect = false,
  onSelectCampaign
}) => {
  const [ordersData, setOrdersData] = useState<GroupedOrderData>({});
  const [anomalies, setAnomalies] = useState<{ [campaignId: string]: Anomaly[] }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [anomaliesLoading, setAnomaliesLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [sortConfig, setSortConfig] = useState<SortConfig>({ key: '', direction: 'none' });
  const [selectedAnomaly, setSelectedAnomaly] = useState<Anomaly | null>(null);
  const [showAnomalyModal, setShowAnomalyModal] = useState<boolean>(false);

  // =================================================================
// FB STATUSES: state + helpers (вставить после последнего useState)
// =================================================================
const [fbStatusById, setFbStatusById] = useState<Record<string, string>>({});
const [fbStatusByName, setFbStatusByName] = useState<Record<string, string>>({});

// Берём статус по id (если есть), иначе по точному названию кампании.
// ТЕКСТ НЕ МЕНЯЕМ — возвращаем как есть.
const getFbStatusForItem = (item: OrderData): string | undefined => {
  const id = item.campaign_id ? String(item.campaign_id) : '';
  if (id && fbStatusById[id]) return fbStatusById[id];
  const name = (item.campaign || '').trim();
  if (name && fbStatusByName[name]) return fbStatusByName[name];
  return undefined;
};

// Бейдж с нейтральным оформлением, НО БЕЗ изменения текста статуса
const renderFbStatusBadge = (status?: string) => {
  if (!status) return null;
  return (
    <span
      style={{
        marginLeft: 8,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 12,
        border: '1px solid #e5e7eb',
        color: '#374151',
        background: '#f3f4f6',
        whiteSpace: 'nowrap'
      }}
      title="FB Campaign Status"
    >
      {status}
    </span>
  );
};

// =================================================================
// FB ACTION BADGE: state + helpers (вставить сразу после fbStatusById/fbStatusByName)
// =================================================================
const [fbUpdating, setFbUpdating] = useState<Record<string, boolean>>({});

// ID кампании должен быть числовым (как в /fbads/list/ и /fbads/update/)
const isNumericId = (v: any) => /^\d+$/.test(String(v ?? '').trim());

// Можно ли управлять этой строкой (только строки кампаний и только если id числовой)
const isActionable = (item: OrderData, isCountryRow: boolean, isGrandTotalRow: boolean) =>
  !isCountryRow && !isGrandTotalRow && isNumericId(item.campaign_id);

// Текущий → следующий статус (ACTIVE ↔ PAUSED)
const getNextStatus = (current?: string) => (String(current).toUpperCase() === 'ACTIVE' ? 'PAUSED' : 'ACTIVE');

// Подпись на кнопке (по-русски)
const getActionLabel = (nextStatus: string) => (String(nextStatus).toUpperCase() === 'ACTIVE' ? 'START' : 'STOP');

// Стиль кнопки действия — другой приятный цвет, чем у статус-бейджа.
// Для "Начать" (цель ACTIVE) — синий, для "Остановить" (цель PAUSED) — розово-красный.
// При лоадинге слегка глушим цвета и блокируем курсор.
const getActionBadgeStyle = (nextStatus: string, loading: boolean): React.CSSProperties => {
  const toActive = String(nextStatus).toUpperCase() === 'ACTIVE';
  const base: React.CSSProperties = toActive
    ? {
        background: 'rgba(59,130,246,0.12)', // синий светлый
        color: '#1d4ed8',
        border: '1px solid rgba(59,130,246,0.35)',
      }
    : {
        background: 'rgba(244,63,94,0.12)', // розово-красный светлый
        color: '#be123c',
        border: '1px solid rgba(244,63,94,0.35)',
      };
  return {
    padding: '2px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    cursor: loading ? 'progress' : 'pointer',
    opacity: loading ? 0.7 : 1,
    ...base,
  };
};

// Ключ для map "fbUpdating": всегда используем id (если он валиден)
const getUpdateKey = (item: OrderData) => String(item.campaign_id ?? '');

// Основной POST на обновление статуса. Обновляем локальную мапу статусов при 200 OK.
const toggleFbStatus = async (item: OrderData, currentStatus?: string) => {
  const id = String(item.campaign_id ?? '').trim();
  if (!isNumericId(id)) return;

  const next = getNextStatus(currentStatus);
  const key = id;

  try {
    setFbUpdating(prev => ({ ...prev, [key]: true }));

    const resp = await fetch('https://dtapp05.golive.mobi/api/stf/fbads/update/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ campaign_id: id, status: next }), // ТЕЛО РОВНО КАК В ТЗ
    });

    if (resp.ok) {
      // Обновляем только локальные мапы бейджей, НЕ трогая orders
      setFbStatusById(prev => ({ ...prev, [id]: next }));
      if (item.campaign) {
        const name = String(item.campaign);
        setFbStatusByName(prev => ({ ...prev, [name]: next }));
      }
    } else {
      // 500 или иное — ничего не делаем (по ТЗ)
      // Можно добавить console.warn для отладки:
      console.warn('FB update failed with status:', resp.status);
    }
  } catch (e) {
    // Сетевая ошибка — тоже ничего не делаем (бейдж вернётся к прежнему)
    console.warn('FB update error:', e);
  } finally {
    setFbUpdating(prev => ({ ...prev, [key]: false }));
  }
};

  // ===================== Базовые функции =====================
  const getNumericValue = (value: any): number => {
    if (value === null || value === undefined || value === '') return 0;
    const num = parseFloat(String(value));
    return isNaN(num) ? 0 : num;
  };

  const getVatRate = (country: string): number =>
    vatRates[country] !== undefined ? vatRates[country] : 0.0;

  const getAdjustedRevenue = (value: number | null, country: string): number => {
    const numericValue = getNumericValue(value);
    if (!showWithTax) return numericValue;
    const vatRate = getVatRate(country);
    return numericValue * (1 - vatRate);
  };

  const getHistoricCoeff = (item: OrderData): number =>
    getNumericValue(item.historic_coeff) || 1;

  // ===================== Цвета/фон =====================
  const getValueColor = (value: number): string => {
    if (value > 0) return '#10b981';
    if (value === 0) return '#374151';
    return '#ef4444';
  };
  const GREEN_SOLID = '#10b98145';
  const RED_SOLID   = '#ef444447';
  const YELLOW_SOLID= '#f59f0b48';
  const GREEN_LIGHT = 'rgba(16, 185, 129, 0.15)';
  const RED_LIGHT   = 'rgba(239, 68, 68, 0.15)';
  const YELLOW_LIGHT= 'rgba(245, 158, 11, 0.15)';

  const getRowBackgroundColor = (item: OrderData, isGrandTotalRow: boolean = false): string => {
    const profit = calculateTotalRevenue(item) - getNumericValue(item.costs);
    const roi = calculateROI(item);
    const predictedRoi = calculatePredictedROI(item);
    const vals = [profit, roi, predictedRoi];
    const positives = vals.filter(v => v > 0).length;
    const negatives = vals.filter(v => v < 0).length;
    const zeros     = 3 - positives - negatives;
    if (positives === 3) return isGrandTotalRow ? GREEN_SOLID : GREEN_LIGHT;
    if (negatives === 3) return isGrandTotalRow ? RED_SOLID : RED_LIGHT;
    if (negatives === 0 && positives === 1 && zeros === 2) return isGrandTotalRow ? GREEN_SOLID : GREEN_LIGHT;
    return isGrandTotalRow ? YELLOW_SOLID : YELLOW_LIGHT;
  };

  const getRowHoverColor = (item: OrderData, isGrandTotalRow: boolean = false): string => {
    const profit = calculateTotalRevenue(item) - getNumericValue(item.costs);
    const roi = calculateROI(item);
    const predictedRoi = calculatePredictedROI(item);
    const vals = [profit, roi, predictedRoi];
    const positives = vals.filter(v => v > 0).length;
    const negatives = vals.filter(v => v < 0).length;
    const zeros     = 3 - positives - negatives;
    if (positives === 3) return isGrandTotalRow ? '#059669' : 'rgba(16, 185, 129, 0.25)';
    if (negatives === 3) return isGrandTotalRow ? '#dc2626' : 'rgba(239, 68, 68, 0.25)';
    if (negatives === 0 && positives === 1 && zeros === 2) return isGrandTotalRow ? '#059669' : 'rgba(16, 185, 129, 0.25)';
    return isGrandTotalRow ? '#d97706' : 'rgba(245, 158, 11, 0.25)';
  };

  // ===================== ИСПРАВЛЕННЫЕ Predicted / Early функции (24 периода) =====================
  
  // ИСПРАВЛЕНО: теперь работает с 24 периодами как в первом компоненте
  const calculatePredictedRevenueArray = (item: OrderData): (number | null)[] => {
    const predictedRevenueArray: (number | null)[] = [];

    for (let i = 1; i <= 24; i++) { // 24 периода
      const revenueKey = `revenue_p${i}` as keyof OrderData;
      const churnKey = `predicted_churn_p${i}` as keyof OrderData;
      
      if (i === 1) {
        // predicted_revenue_p1 = revenue_p1 (всегда)
        const revenue_p1 = getNumericValue(item[revenueKey]);
        predictedRevenueArray[i-1] = revenue_p1;
      } else {
        // predicted_revenue_pi = revenue_p(i-1) * (predicted_churn_pi / 100)
        const prevRevenueKey = `revenue_p${i-1}` as keyof OrderData;
        const prevRevenue = getNumericValue(item[prevRevenueKey]);
        const churnValue = getNumericValue(item[churnKey]);
        
        predictedRevenueArray[i-1] = prevRevenue * (churnValue / 100.0);
      }
    }
    
    return predictedRevenueArray;
  };

  const enrichOrderDataWithPredictedRevenue = (item: OrderData): OrderData => {
    const predictedArray = calculatePredictedRevenueArray(item);
    const enrichedItem = { ...item };
    
    for (let i = 1; i <= 24; i++) { // 24 периода
      const fieldKey = `predicted_revenue_p${i}` as keyof OrderData;
      (enrichedItem[fieldKey] as any) = predictedArray[i - 1];
    }
    
    return enrichedItem;
  };

  // ИСПРАВЛЕНО: используем ту же логику что и в первом компоненте
  const calculateEarlyPredictedRevenueArray = (item: OrderData): (number | null)[] => {
    const predictedRevenueArray: (number | null)[] = [];
    
    // Рассчитываем predicted_revenue для всех 24 периодов (как в первом компоненте)
    for (let i = 1; i <= 24; i++) {
      const revenueKey = `revenue_p${i}` as keyof OrderData;
      const churnKey = `predicted_churn_p${i}` as keyof OrderData;
      
      const actualRevenue = getNumericValue(item[revenueKey]);
      
      if (i === 1) {
        // Для P1: используем фактический доход если он есть, иначе 0
        predictedRevenueArray[i-1] = actualRevenue > 0 ? actualRevenue : 0;
      } else {
        const churnValue = getNumericValue(item[churnKey]);
        if (actualRevenue > 0) {
          // Если есть фактический доход - используем его
          predictedRevenueArray[i-1] = actualRevenue;
        } else {
          // Иначе рассчитываем по формуле: prev_predicted * (churn / 100)
          const prevPredicted = predictedRevenueArray[i-2] || 0;
          predictedRevenueArray[i-1] = prevPredicted * (churnValue / 100.0);
        }
      }
    }
    
    return predictedRevenueArray;
  };

  const enrichOrderDataWithEarlyPredicted = (item: OrderData): OrderData => {
    const predictedArray = calculateEarlyPredictedRevenueArray(item);
    const enrichedItem = { ...item };
    
    // Сохраняем predicted_revenue для периодов 1-24
    for (let i = 1; i <= 24; i++) {
      const fieldKey = `predicted_revenue_p${i}` as keyof OrderData;
      (enrichedItem[fieldKey] as any) = predictedArray[i - 1];
    }
    
    // Рассчитываем накопительные early_predict (как в первом компоненте)
    for (let i = 1; i <= 24; i++) {
      const earlyPredictKey = `early_predicted_revenue_p${i}` as keyof OrderData;
      // early_predict_pi = сумма predicted_revenue_p1..pi
      let cumulativeSum = 0;
      for (let j = 1; j <= i; j++) {
        cumulativeSum += predictedArray[j - 1] || 0;
      }
      (enrichedItem[earlyPredictKey] as any) = cumulativeSum;
    }
    
    return enrichedItem;
  };

  // ===================== ИСПРАВЛЕННЫЕ метрики (24 периода) =====================
  
  // ИСПРАВЛЕНО: 24 периода вместо 12
  const calculateTotalRevenue = (item: OrderData): number => {
    // Если это агрегированная строка, используем уже посчитанное значение
    if ((item as any).aggregated_total_revenue !== undefined) {
      return getNumericValue((item as any).aggregated_total_revenue);
    }
    
    // Для отдельных записей считаем заново
    let total = getAdjustedRevenue(getNumericValue(item.revenue_activation_original), item.country) +
                getAdjustedRevenue(getNumericValue(item.revenue_activation_purchase), item.country);
    for (let i = 1; i <= 24; i++) { // ИСПРАВЛЕНО: 24 периода вместо 12
      const revenueKey = `revenue_p${i}` as keyof OrderData;
      total += getAdjustedRevenue(getNumericValue((item as any)[revenueKey]), item.country);
    }
    return total;
  };

  // ИСПРАВЛЕНО: НЕ включаем revenue_activation как в первом компоненте + 24 периода
  const calculateTotalPredictedRevenue = (item: OrderData): number => {
  // Если это агрегированная строка, используем уже посчитанное значение
  if ((item as any).aggregated_predicted_revenue !== undefined) {
    return getNumericValue((item as any).aggregated_predicted_revenue);
  }
  
  // Для отдельных записей считаем прогноз
  const enrichedItem = enrichOrderDataWithPredictedRevenue(item); 
  
  // ИЗМЕНЕНИЕ: Начинаем расчет с доходов от активации, как и для Total Revenue
  let total = getAdjustedRevenue(getNumericValue(item.revenue_activation_original), item.country) +
              getAdjustedRevenue(getNumericValue(item.revenue_activation_purchase), item.country);
  
  // Затем добавляем все предсказанные доходы
  for (let i = 1; i <= 24; i++) { // 24 периода
    const key = `predicted_revenue_p${i}` as keyof OrderData;
    const rawValue = (enrichedItem as any)[key];
    total += getAdjustedRevenue(getNumericValue(rawValue), item.country);
  }
  return total;
};

  // ИСПРАВЛЕНО: используем ту же логику что и в первом компоненте
  const calculateEarlyPredictedRevenue = (item: OrderData): number => {
    // Если это агрегированная строка, используем уже посчитанное значение
    if ((item as any).aggregated_early_predicted_revenue !== undefined) {
      return getNumericValue((item as any).aggregated_early_predicted_revenue);
    }
    
    // Для отдельных записей рассчитываем по логике первого компонента
    // total_early_predict = сумма всех predicted_revenue_p1..p24
    const predictedArray = calculateEarlyPredictedRevenueArray(item);
    
    // Применяем VAT к каждому периоду и суммируем
    let totalSum = 0;
    for (let i = 0; i < predictedArray.length; i++) {
      const rawValue = predictedArray[i] || 0;
      totalSum += getAdjustedRevenue(rawValue, item.country);
    }
    
    return totalSum;
  };

  const calculateEarlyPredictedLTV = (item: OrderData): number => {
    const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
    const activationCount = getNumericValue(item.count_unique_payers_activation);
    return activationCount > 0 ? earlyPredictedRevenue / activationCount : 0;
  };

  const calculateEarlyPredictedROI = (item: OrderData): number => {
    const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
    const costs = getNumericValue(item.costs);
    return costs > 0 ? ((earlyPredictedRevenue - costs) / costs) * 100 : 0;
  };

  const calculateARPPU = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const uniquePayers = getNumericValue(item.count_unique_payers);
    return uniquePayers > 0 ? totalRevenue / uniquePayers : 0;
  };

  const calculateLTV = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const activationCount = getNumericValue(item.count_unique_payers_activation);
    return activationCount > 0 ? totalRevenue / activationCount : 0;
  };

  const calculatePredictedLTV = (item: OrderData): number => {
    const predictedRevenue = calculateTotalPredictedRevenue(item);
    const activationCount = getNumericValue(item.count_unique_payers_activation);
    return activationCount > 0 ? predictedRevenue / activationCount : 0;
  };

  const calculateCPU = (item: OrderData): number => {
    const costs = getNumericValue(item.costs);
    const uniquePayers = getNumericValue(item.count_unique_payers);
    return uniquePayers > 0 ? costs / uniquePayers : 0;
  };

  const calculateCPA = (item: OrderData): number => {
    const costs = getNumericValue(item.costs);
    const activationPurchases = getNumericValue(item.revenue_activation_purchase_count);
    return activationPurchases > 0 ? costs / activationPurchases : 0;
  };

  const calculateROI = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const costs = getNumericValue(item.costs);
    return costs > 0 ? ((totalRevenue - costs) / costs) * 100 : 0;
  };

  const calculatePredictedROI = (item: OrderData): number => {
    const predictedRevenue = calculateTotalPredictedRevenue(item);
    const costs = getNumericValue(item.costs);
    return costs > 0 ? ((predictedRevenue - costs) / costs) * 100 : 0;
  };

  const getColumnValue = (item: OrderData, column: string): number => {
    switch(column) {
      case 'revenue_activation':
        return getAdjustedRevenue(getNumericValue(item.revenue_activation_original), item.country);
      case 'revenue_activation_purchase':
        return getAdjustedRevenue(getNumericValue(item.revenue_activation_purchase), item.country);  
      case 'costs':
        return getNumericValue(item.costs);
      case 'total_revenue':
        return calculateTotalRevenue(item);
      case 'profit':
        return calculateTotalRevenue(item) - getNumericValue(item.costs);
      case 'roi':
        return calculateROI(item);
      case 'predicted_roi':
        return calculatePredictedROI(item);
      case 'early_predicted_roi':
        return calculateEarlyPredictedROI(item);
      case 'total_early_predicted_revenue':
        return calculateEarlyPredictedRevenue(item);
      case 'cpa_cost_per_action':
        return calculateCPA(item);
      case 'cpu_cost_per_user':
        return calculateCPU(item);
      case 'ltv':
        return calculateLTV(item);
      case 'predicted_ltv':
        return calculatePredictedLTV(item);
      case 'early_predicted_ltv':
        return calculateEarlyPredictedLTV(item);
      case 'arppu':
        return calculateARPPU(item);
      case 'total_predicted_revenue':
        return calculateTotalPredictedRevenue(item);
      case 'revenue_activation_count':
        return getNumericValue(item.revenue_activation_count);
      case 'revenue_activation_purchase_count':
        return getNumericValue(item.revenue_activation_purchase_count);
      case 'count_unique_payers':
        return getNumericValue(item.count_unique_payers);
      case 'count_unique_payers_activation':
        return getNumericValue(item.count_unique_payers_activation);
      case 'revenue_p1': case 'revenue_p2': case 'revenue_p3': case 'revenue_p4':
      case 'revenue_p5': case 'revenue_p6': case 'revenue_p7': case 'revenue_p8':
      case 'revenue_p9': case 'revenue_p10': case 'revenue_p11': case 'revenue_p12':
      case 'revenue_p13': case 'revenue_p14': case 'revenue_p15': case 'revenue_p16':
      case 'revenue_p17': case 'revenue_p18': case 'revenue_p19': case 'revenue_p20':
      case 'revenue_p21': case 'revenue_p22': case 'revenue_p23': case 'revenue_p24':
        return getAdjustedRevenue(getNumericValue(item[column as keyof OrderData]), item.country);
      default:
        return 0;
    }
  };

  // ===================== ИСПРАВЛЕННАЯ Агрегация набора (24 периода) =====================
  const aggregateItemsCorrectly = (items: OrderData[], targetCountry: string, targetCampaign?: string): OrderData => {
    const aggregated: OrderData = {
      date_activation: `${dateFrom} - ${dateTo}`,
      country: targetCountry,
      campaign: targetCampaign || (targetCountry === 'All' ? 'Total' : targetCountry),
      campaign_id: items[0]?.campaign_id || undefined,
      platform: items[0]?.platform || '---',
      historic_coeff: 1,
      arppu: 0, ltv: 0, predicted_ltv: 0, cpa_cost_per_action: 0, cpu_cost_per_user: 0, roi: 0, predicted_roi: 0,
      revenue_activation_count: 0, revenue_activation_purchase_count: 0, 
      revenue_activation_purchase: 0,
      revenue_activation: 0,
      revenue_activation_original: 0,
      costs: 0,
      total_revenue: 0, total_predicted_revenue: 0, count_unique_payers: 0, count_unique_payers_activation: 0,
      // ИСПРАВЛЕНО: добавляем все 24 периода
      revenue_p1: 0, revenue_p1_count: 0, revenue_p2: 0, revenue_p2_count: 0,
      revenue_p3: 0, revenue_p3_count: 0, revenue_p4: 0, revenue_p4_count: 0,
      revenue_p5: 0, revenue_p5_count: 0, revenue_p6: 0, revenue_p6_count: 0,
      revenue_p7: 0, revenue_p7_count: 0, revenue_p8: 0, revenue_p8_count: 0,
      revenue_p9: 0, revenue_p9_count: 0, revenue_p10: 0, revenue_p10_count: 0,
      revenue_p11: 0, revenue_p11_count: 0, revenue_p12: 0, revenue_p12_count: 0,
      revenue_p13: 0, revenue_p13_count: 0, revenue_p14: 0, revenue_p14_count: 0,
      revenue_p15: 0, revenue_p15_count: 0, revenue_p16: 0, revenue_p16_count: 0,
      revenue_p17: 0, revenue_p17_count: 0, revenue_p18: 0, revenue_p18_count: 0,
      revenue_p19: 0, revenue_p19_count: 0, revenue_p20: 0, revenue_p20_count: 0,
      revenue_p21: 0, revenue_p21_count: 0, revenue_p22: 0, revenue_p22_count: 0,
      revenue_p23: 0, revenue_p23_count: 0, revenue_p24: 0, revenue_p24_count: 0,
      
      // ИСПРАВЛЕНО: добавляем все 24 периода для early_predicted
      early_predicted_revenue_p1: 0, early_predicted_revenue_p2: 0, early_predicted_revenue_p3: 0, early_predicted_revenue_p4: 0,
      early_predicted_revenue_p5: 0, early_predicted_revenue_p6: 0, early_predicted_revenue_p7: 0, early_predicted_revenue_p8: 0,
      early_predicted_revenue_p9: 0, early_predicted_revenue_p10: 0, early_predicted_revenue_p11: 0, early_predicted_revenue_p12: 0,
      early_predicted_revenue_p13: 0, early_predicted_revenue_p14: 0, early_predicted_revenue_p15: 0, early_predicted_revenue_p16: 0,
      early_predicted_revenue_p17: 0, early_predicted_revenue_p18: 0, early_predicted_revenue_p19: 0, early_predicted_revenue_p20: 0,
      early_predicted_revenue_p21: 0, early_predicted_revenue_p22: 0, early_predicted_revenue_p23: 0, early_predicted_revenue_p24: 0,
      
      // ИСПРАВЛЕНО: добавляем все 24 периода для predicted_revenue
      predicted_revenue_p1: 0, predicted_revenue_p2: 0, predicted_revenue_p3: 0, predicted_revenue_p4: 0,
      predicted_revenue_p5: 0, predicted_revenue_p6: 0, predicted_revenue_p7: 0, predicted_revenue_p8: 0,
      predicted_revenue_p9: 0, predicted_revenue_p10: 0, predicted_revenue_p11: 0, predicted_revenue_p12: 0,
      predicted_revenue_p13: 0, predicted_revenue_p14: 0, predicted_revenue_p15: 0, predicted_revenue_p16: 0,
      predicted_revenue_p17: 0, predicted_revenue_p18: 0, predicted_revenue_p19: 0, predicted_revenue_p20: 0,
      predicted_revenue_p21: 0, predicted_revenue_p22: 0, predicted_revenue_p23: 0, predicted_revenue_p24: 0,
      
      // ИСПРАВЛЕНО: добавляем все 24 периода для predicted_churn
      predicted_churn_p1: 0, predicted_churn_p2: 0, predicted_churn_p3: 0, predicted_churn_p4: 0,
      predicted_churn_p5: 0, predicted_churn_p6: 0, predicted_churn_p7: 0, predicted_churn_p8: 0,
      predicted_churn_p9: 0, predicted_churn_p10: 0, predicted_churn_p11: 0, predicted_churn_p12: 0,
      predicted_churn_p13: 0, predicted_churn_p14: 0, predicted_churn_p15: 0, predicted_churn_p16: 0,
      predicted_churn_p17: 0, predicted_churn_p18: 0, predicted_churn_p19: 0, predicted_churn_p20: 0,
      predicted_churn_p21: 0, predicted_churn_p22: 0, predicted_churn_p23: 0, predicted_churn_p24: 0,
    };
    
    let totalEarlyPredictedRevenue = 0;
    let totalPredictedRevenueSum = 0;
    let totalRevenueSum = 0;

    items.forEach(item => {
      const itemTotalRevenue = calculateTotalRevenue(item);
      const itemTotalPredictedRevenue = calculateTotalPredictedRevenue(item);
      const itemEarlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
      totalRevenueSum += itemTotalRevenue;
      totalPredictedRevenueSum += itemTotalPredictedRevenue;
      totalEarlyPredictedRevenue += itemEarlyPredictedRevenue;

      aggregated.revenue_activation_count += getNumericValue(item.revenue_activation_count);
      (aggregated.revenue_activation_purchase_count as number) += getNumericValue(item.revenue_activation_purchase_count);
      (aggregated.revenue_activation_original as number) += getAdjustedRevenue(getNumericValue(item.revenue_activation_original), item.country);
      (aggregated.revenue_activation_purchase as number) += getAdjustedRevenue(getNumericValue(item.revenue_activation_purchase), item.country);
      (aggregated.costs as number) += getNumericValue(item.costs); 
      (aggregated.count_unique_payers as number) += getNumericValue(item.count_unique_payers);
      (aggregated.count_unique_payers_activation as number) += getNumericValue(item.count_unique_payers_activation);

      // ИСПРАВЛЕНО: суммируем периоды P1-P24 (фактические данные)
      for (let i = 1; i <= 24; i++) {
        const revenueKey = `revenue_p${i}` as keyof OrderData;
        const countKey = `revenue_p${i}_count` as keyof OrderData;
        (aggregated as any)[revenueKey] = ((aggregated as any)[revenueKey] || 0) + getAdjustedRevenue(getNumericValue((item as any)[revenueKey]), item.country);
        (aggregated as any)[countKey] = ((aggregated as any)[countKey] || 0) + getNumericValue((item as any)[countKey]);
      }

      // Суммируем early predicted периоды для этого элемента
      const enrichedItem = enrichOrderDataWithEarlyPredicted(item);
      for (let i = 1; i <= 24; i++) { // 24 периода как в первом компоненте
        const earlyPredictedKey = `early_predicted_revenue_p${i}` as keyof OrderData;
        const earlyPredictedValue = getNumericValue(enrichedItem[earlyPredictedKey]);
        const adjustedEarlyPredictedValue = getAdjustedRevenue(earlyPredictedValue, item.country);
        (aggregated as any)[earlyPredictedKey] = ((aggregated as any)[earlyPredictedKey] || 0) + adjustedEarlyPredictedValue;
      }
    });

    (aggregated as any).aggregated_total_revenue = totalRevenueSum;
    (aggregated as any).aggregated_predicted_revenue = totalPredictedRevenueSum;
    (aggregated as any).aggregated_early_predicted_revenue = totalEarlyPredictedRevenue;

    (aggregated.total_revenue as number) = totalRevenueSum;
    (aggregated.total_predicted_revenue as number) = totalPredictedRevenueSum;

    const costs = getNumericValue(aggregated.costs);
    const uniquePayers = getNumericValue(aggregated.count_unique_payers);
    const activationPayers = getNumericValue(aggregated.count_unique_payers_activation);
    const purchases = getNumericValue(aggregated.revenue_activation_purchase_count);

    aggregated.arppu = uniquePayers > 0 ? totalRevenueSum / uniquePayers : 0;
    aggregated.ltv = activationPayers > 0 ? totalRevenueSum / activationPayers : 0;
    aggregated.cpa_cost_per_action = purchases > 0 ? costs / purchases : 0;
    aggregated.cpu_cost_per_user = uniquePayers > 0 ? costs / uniquePayers : 0;
    aggregated.roi = costs > 0 ? ((totalRevenueSum - costs) / costs) * 100 : 0;
    aggregated.predicted_ltv = activationPayers > 0 ? totalPredictedRevenueSum / activationPayers : 0;
    aggregated.predicted_roi = costs > 0 ? ((totalPredictedRevenueSum - costs) / costs) * 100 : 0;

    return aggregated;
  };

  // ===================== Фильтр исходных элементов =====================
  const getFilteredItems = (): OrderData[] => {
    const allItems: OrderData[] = [];
    Object.values(ordersData).forEach(dateData => {
      Object.values(dateData).forEach(countryItems => {
        allItems.push(...countryItems);
      });
    });
    return allItems.filter(item => {
      const countryMatch  = selectedCountries.length === 0 || selectedCountries.includes(item.country);
      const campaignMatch = selectedCampaigns.length === 0 || selectedCampaigns.includes(item.campaign || '---');
      const platformMatch = selectedPlatforms.length === 0 || selectedPlatforms.includes(item.platform || '---');
      return countryMatch && campaignMatch && platformMatch;
    });
  };

  // ===================== Размазывание (не используем в daily) =====================
  const distribute_campaigns_advanced = (
    data: AggregatedData,
    distribute_unknowns: boolean = false,
    distribute_direct: boolean = false,
    globalDistribution: boolean = false
  ): AggregatedData => {
    if (!distribute_unknowns && !distribute_direct) return data;
    const distributed_data = { ...data };

    function should_distribute_campaign(campaign_name: string, du: boolean, dd: boolean): boolean {
      const name_lower = campaign_name.toLowerCase().trim();
      const direct_patterns = ['direct', '(direct)'];
      const unknown_patterns = ['---', '(not set)', 'unknown', '(unknown)'];
      const is_direct = direct_patterns.some(p => name_lower === p || name_lower.startsWith(p));
      const is_unknown = unknown_patterns.some(p => name_lower === p || name_lower.startsWith(p)) && !is_direct;
      if (is_direct && dd) return true;
      if (is_unknown && du) return true;
      return false;
    }

    function is_valid_recipient_campaign(campaign_name: string): boolean {
      const name_lower = campaign_name.toLowerCase().trim();
      const source_patterns = ['direct', '(direct)', '---', '(not set)', 'unknown', '(unknown)'];
      const is_source = source_patterns.some(p => name_lower === p || name_lower.startsWith(p));
      return !is_source;
    }

    // ИСПРАВЛЕНО: добавляем поля для 24 периодов
    const numeric_fields_to_distribute = [
      'costs', 'revenue_activation_original', 'revenue_activation_purchase',
      'total_revenue', 'revenue_activation'
    ];
    for (let i = 1; i <= 24; i++) {
      numeric_fields_to_distribute.push(`revenue_p${i}`, `predicted_revenue_p${i}`);
    }

    if (globalDistribution) {
      const all_campaigns = Object.entries(distributed_data);
      const campaigns_to_distribute: [string, OrderData][] = [];
      const valid_recipients: [string, OrderData][] = [];
      all_campaigns.forEach(([key, campaign]) => {
        const campaign_name = campaign.campaign || '---';
        if (should_distribute_campaign(campaign_name, distribute_unknowns, distribute_direct)) {
          campaigns_to_distribute.push([key, campaign]);
        } else if (is_valid_recipient_campaign(campaign_name)) {
          valid_recipients.push([key, campaign]);
        }
      });
      if (!valid_recipients.length || !campaigns_to_distribute.length) return distributed_data;
      const P_values: { [key: string]: number } = {};
      for (const field of numeric_fields_to_distribute) {
        P_values[field] = campaigns_to_distribute.reduce((sum, [, campaign]) => 
          sum + (getNumericValue((campaign as any)[field])), 0);
      }
      const S_total_revenue = valid_recipients.reduce((sum, [, campaign]) => 
        sum + getNumericValue(campaign.total_revenue), 0);
      if (S_total_revenue > 0) {
        valid_recipients.forEach(([key, campaign]) => {
          const A0_revenue = getNumericValue(campaign.total_revenue);
          const share = A0_revenue / S_total_revenue;
          for (const field of numeric_fields_to_distribute) {
            if (P_values[field] !== 0) {
              (campaign as any)[field] = (getNumericValue((campaign as any)[field])) + (P_values[field] * share);
            }
          }
          distributed_data[key] = campaign;
        });
      } else if (valid_recipients.length > 0) {
        const share_per_campaign = 1.0 / valid_recipients.length;
        valid_recipients.forEach(([key, campaign]) => {
          for (const field of numeric_fields_to_distribute) {
            if (P_values[field] !== 0) {
              (campaign as any)[field] = (getNumericValue((campaign as any)[field])) + (P_values[field] * share_per_campaign);
            }
          }
          distributed_data[key] = campaign;
        });
      }
      valid_recipients.forEach(([key, campaign]) => {
        const total_revenue = getNumericValue(campaign.total_revenue);
        const costs = getNumericValue(campaign.costs);
        const count_unique_payers = getNumericValue(campaign.count_unique_payers);
        const count_unique_payers_activation = getNumericValue(campaign.count_unique_payers_activation);
        (campaign as any).profit = total_revenue - costs;
        campaign.roi = costs > 0 ? ((total_revenue - costs) / costs) * 100 : 0;
        campaign.ltv = count_unique_payers_activation > 0 ? total_revenue / count_unique_payers_activation : 0;
        campaign.arppu = count_unique_payers > 0 ? total_revenue / count_unique_payers : 0;
        distributed_data[key] = campaign;
      });
      campaigns_to_distribute.forEach(([key]) => delete distributed_data[key]);
    } else {
      const countryGroups: { [country: string]: [string, OrderData][] } = {};
      Object.entries(distributed_data).forEach(([key, campaign]) => {
        const country = campaign.country;
        if (!countryGroups[country]) countryGroups[country] = [];
        countryGroups[country].push([key, campaign]);
      });
      Object.entries(countryGroups).forEach(([country, campaigns]) => {
        const campaigns_to_distribute: [string, OrderData][] = [];
        const valid_recipients: [string, OrderData][] = [];
        campaigns.forEach(([key, campaign]) => {
          const campaign_name = campaign.campaign || '---';
          if (key === country || key === 'Total') return; // агрегаты не трогаем
          if (should_distribute_campaign(campaign_name, distribute_unknowns, distribute_direct)) {
            campaigns_to_distribute.push([key, campaign]);
          } else if (is_valid_recipient_campaign(campaign_name)) {
            valid_recipients.push([key, campaign]);
          }
        });
        if (!valid_recipients.length || !campaigns_to_distribute.length) return;
        const P_values: { [key: string]: number } = {};
        for (const field of numeric_fields_to_distribute) {
          P_values[field] = campaigns_to_distribute.reduce((sum, [, campaign]) => 
            sum + (getNumericValue((campaign as any)[field])), 0);
        }
        const S_total_revenue = valid_recipients.reduce((sum, [, campaign]) => 
          sum + getNumericValue(campaign.total_revenue), 0);
        if (S_total_revenue > 0) {
          valid_recipients.forEach(([key, campaign]) => {
            const A0_revenue = getNumericValue(campaign.total_revenue);
            const share = A0_revenue / S_total_revenue;
            for (const field of numeric_fields_to_distribute) {
              if (P_values[field] !== 0) {
                (campaign as any)[field] = (getNumericValue((campaign as any)[field])) + (P_values[field] * share);
              }
            }
            distributed_data[key] = campaign;
          });
        } else if (valid_recipients.length > 0) {
          const share_per_campaign = 1.0 / valid_recipients.length;
          valid_recipients.forEach(([key, campaign]) => {
            for (const field of numeric_fields_to_distribute) {
              if (P_values[field] !== 0) {
                (campaign as any)[field] = (getNumericValue((campaign as any)[field])) + (P_values[field] * share_per_campaign);
              }
            }
            distributed_data[key] = campaign;
          });
        }
        valid_recipients.forEach(([key, campaign]) => {
          const total_revenue = getNumericValue(campaign.total_revenue);
          const costs = getNumericValue(campaign.costs);
          const count_unique_payers = getNumericValue(campaign.count_unique_payers);
          const count_unique_payers_activation = getNumericValue(campaign.count_unique_payers_activation);
          (campaign as any).profit = total_revenue - costs;
          campaign.roi = costs > 0 ? ((total_revenue - costs) / costs) * 100 : 0;
          campaign.ltv = count_unique_payers_activation > 0 ? total_revenue / count_unique_payers_activation : 0;
          campaign.arppu = count_unique_payers > 0 ? total_revenue / count_unique_payers : 0;
          distributed_data[key] = campaign;
        });
        campaigns_to_distribute.forEach(([key]) => delete distributed_data[key]);
      });
    }
    return distributed_data;
  };

  // ===================== API: orders =====================
  useEffect(() => {
    const fetchOrdersData = async () => {
      setLoading(true);
      try {
        const endpoint = `/api/${database}/orders`;
        const params: Record<string, any> = {};
        params.country = true;
        params.distribute_unknowns = distributeUnknowns;
        params.distribute_direct = distributeDirect;
        params.keyevent = viewMode === 'daily' ? 'days' : 'month';
        params.date_from = dateFrom;
        params.date_to = dateTo;
        if (selectedCountries.length > 0) params.country_filter = selectedCountries.join(',');
        if (selectedCampaigns.length > 0) params.campaign = selectedCampaigns.join(',');
        const queryString = new URLSearchParams(params).toString();
        const response = await fetch(getApiUrl(`${endpoint}?${queryString}`));
        if (!response.ok) throw new Error('Network response was not ok');
        const responseData = await response.json();
        const orderData = responseData.data || {};
        setOrdersData(orderData);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch orders data:', err);
        setError('Failed to fetch orders data');
      } finally {
        setLoading(false);
      }
    };
    fetchOrdersData();
  }, [
    database,
    selectedCountries,
    selectedCampaigns,
    selectedPlatforms,
    dateFrom,
    dateTo,
    viewMode,
    distributeUnknowns,
    distributeDirect
  ]);

  // =================================================================
// FB STATUSES: загрузка с https://dtapp05.golive.mobi/api/stf/fbads/list/
// =================================================================
useEffect(() => {
  let aborted = false;

  const load = async () => {
    try {
      const resp = await fetch('https://dtapp05.golive.mobi/api/stf/fbads/list/');
      if (!resp.ok) throw new Error('Failed to fetch FB statuses');

      const json = await resp.json();

      // Собираем статусы из всех массивов вида [{id,name,status}, ...]
      const byId: Record<string, string> = {};
      const byName: Record<string, string> = {};

      const collect = (arr: any[]) => {
        arr.forEach((o: any) => {
          if (!o) return;
          const sid = o.id != null ? String(o.id) : '';
          const sname = o.name != null ? String(o.name) : '';
          const sstatus = o.status != null ? String(o.status) : '';
          if (sid) byId[sid] = sstatus;
          if (sname) byName[sname] = sstatus;
        });
      };

      // проходим по всем полям-спискам в ответе (например, campaigns_active, campaigns_paused и т.п.)
      Object.values(json).forEach((v: any) => {
        if (Array.isArray(v)) collect(v);
      });

      if (!aborted) {
        setFbStatusById(byId);
        setFbStatusByName(byName);
      }
    } catch {
      if (!aborted) {
        setFbStatusById({});
        setFbStatusByName({});
      }
    }
  };

  load();
  return () => {
    aborted = true;
  };
}, []);

  // ===================== API: anomalies =====================
  useEffect(() => {
    const fetchAnomalies = async () => {
      setAnomaliesLoading(true);
      try {
        const endpoint = `/api/${database}/anomalies`;
        const params: Record<string, any> = {
          date_from: dateFrom,
          date_to: dateTo
        };
        if (selectedCountries.length > 0) params.country = selectedCountries.join(',');
        const queryString = new URLSearchParams(params).toString();
        const response = await fetch(getApiUrl(`${endpoint}?${queryString}`));
        if (!response.ok) throw new Error('Failed to fetch anomalies');
        const responseData = await response.json();
        setAnomalies(responseData.by_campaign || {});
      } catch (err) {
        console.error('Failed to fetch anomalies:', err);
        setAnomalies({});
      } finally {
        setAnomaliesLoading(false);
      }
    };
    fetchAnomalies();
  }, [database, dateFrom, dateTo, selectedCountries, selectedCampaigns]);

  // ===================== Чарт аномалий =====================
  const [chartData, setChartData] = useState<ChartPoint[]>([]);
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  const [chartError, setChartError] = useState<string | null>(null);
  const [seriesVisible, setSeriesVisible] = useState<Record<'cost' | 'revenue' | 'roi', boolean>>({
    cost: true, revenue: true, roi: true,
  });
  const toggleSeries = (key: 'cost' | 'revenue' | 'roi') =>
    setSeriesVisible(s => ({ ...s, [key]: !s[key] }));
  const [prevChartData, setPrevChartData] = useState<ChartPoint[]>([]);
  const [showPrev, setShowPrev] = useState(false);
  const [prevLoading, setPrevLoading] = useState(false);
  const [prevError, setPrevError] = useState<string | null>(null);
  const toYMD = (d: Date) => d.toISOString().slice(0, 10);
  const diffDaysInclusive = (a: string, b: string) => Math.round((+new Date(b) - +new Date(a)) / 86400000) + 1;

  type MergedPoint = ChartPoint & { prev_cost?: number | null; prev_revenue?: number | null; prev_roi?: number | null; };
  const mergeSeries = (curr: ChartPoint[], prev: ChartPoint[]): MergedPoint[] =>
    curr.map((p, i) => ({ ...p, prev_cost: prev[i]?.cost ?? null, prev_revenue: prev[i]?.revenue ?? null, prev_roi: prev[i]?.roi ?? null }));

  const buildChartSeriesFromOrdersDays = (apiData: any, anomaly: Anomaly): ChartPoint[] => {
    const points: ChartPoint[] = [];
    const byDay = apiData?.data || {};
    Object.entries(byDay).forEach(([day, countries]: [string, any]) => {
      const list: OrderData[] = (countries?.[anomaly.country] || []) as OrderData[];
      const item = list.find((it: any) => String(it.campaign_id || '') === String(anomaly.campaign_id || ''));
      if (!item) return;
      const cost = getNumericValue(item.costs);
      const revenue = calculateTotalRevenue(item);
      const roi = cost > 0 ? ((revenue - cost) / cost) * 100 : 0;
      points.push({ date: day, cost, revenue, roi });
    });
    points.sort((a, b) => (a.date < b.date ? -1 : 1));
    return points;
  };

  const fetchAnomalyTimeseries = async (anomaly: Anomaly) => {
    try {
      setChartLoading(true);
      setChartError(null);
      const endpoint = `/api/${database}/orders`;
      const params: Record<string, any> = {
        keyevent: 'days',
        country: true,
        date_from: anomaly.start_date,
        date_to: anomaly.end_date || anomaly.start_date,
        country_filter: anomaly.country,
        campaign: `${anomaly.campaign_name} (${anomaly.campaign_id})`,
        distribute_unknowns: distributeUnknowns,
        distribute_direct: distributeDirect,
      };
      const qs = new URLSearchParams(params).toString();
      const resp = await fetch(getApiUrl(`${endpoint}?${qs}`));
      if (!resp.ok) throw new Error('Failed to load time series');
      const json = await resp.json();
      setChartData(buildChartSeriesFromOrdersDays(json, anomaly));
    } catch (e: any) {
      setChartError(e?.message || 'Failed to load chart');
      setChartData([]);
    } finally {
      setChartLoading(false);
    }
  };

  const fetchPreviousPeriodTimeseries = async (anomaly: Anomaly) => {
    if (!anomaly) return;
    const days = diffDaysInclusive(anomaly.start_date, anomaly.end_date || anomaly.start_date);
    const start = new Date(anomaly.start_date);
    const prevStart = new Date(+start - days * 86400000);
    const prevEnd   = new Date(+start - 1 * 86400000);
    try {
      setPrevLoading(true);
      setPrevError(null);
      const endpoint = `/api/${database}/orders`;
      const params: Record<string, any> = {
        keyevent: 'days',
        country: true,
        date_from: toYMD(prevStart),
        date_to: toYMD(prevEnd),
        country_filter: anomaly.country,
        campaign: `${anomaly.campaign_name} (${anomaly.campaign_id})`,
        distribute_unknowns: distributeUnknowns,
        distribute_direct: distributeDirect,
      };
      const qs = new URLSearchParams(params).toString();
      const resp = await fetch(getApiUrl(`${endpoint}?${qs}`));
      if (!resp.ok) throw new Error('Failed to load previous period');
      const json = await resp.json();
      setPrevChartData(buildChartSeriesFromOrdersDays(json, anomaly));
    } catch (e: any) {
      setPrevError(e?.message || 'Failed to load previous period');
      setPrevChartData([]);
    } finally {
      setPrevLoading(false);
    }
  };

  const onTogglePrev = async () => {
    if (!selectedAnomaly) return;
    if (!showPrev && prevChartData.length === 0) {
      await fetchPreviousPeriodTimeseries(selectedAnomaly);
    }
    setShowPrev(v => !v);
  };

  const getCampaignId = (item: OrderData): string => item.campaign_id ? String(item.campaign_id) : '';

  const hasAnomalies = (item: OrderData): boolean => {
    const campaignId = getCampaignId(item);
    return !!(campaignId && anomalies[campaignId] && anomalies[campaignId].length > 0);
  };

  const getAnomaliesForCampaign = (item: OrderData): Anomaly[] => {
    const campaignId = getCampaignId(item);
    return campaignId ? (anomalies[campaignId] || []) : [];
  };

  const getMostSevereAnomaly = (campaignAnomalies: Anomaly[]): Anomaly | null => {
    if (!campaignAnomalies.length) return null;
    const sorted = campaignAnomalies.sort((a, b) => {
      if (a.severity === 'critical' && b.severity !== 'critical') return -1;
      if (a.severity !== 'critical' && b.severity === 'critical') return 1;
      return 0;
    });
    return sorted[0];
  };

  const handleAnomalyClick = (item: OrderData) => {
    const campaignAnomalies = getAnomaliesForCampaign(item);
    const mostSevere = getMostSevereAnomaly(campaignAnomalies);
    if (mostSevere) {
      setSelectedAnomaly(mostSevere);
      setShowPrev(false);
      setPrevChartData([]);
      setPrevError(null);
      setShowAnomalyModal(true);
      fetchAnomalyTimeseries(mostSevere);
    }
  };

  const handleCampaignClick = (item: OrderData) => {
    if (onSelectCampaign && item.campaign) onSelectCampaign(item.campaign);
  };

  const getAnomalyIcon = (severity: string) => (
    <AlertTriangle 
      size={16} 
      style={{ color: severity === 'critical' ? '#dc3545' : '#ff9800', cursor: 'pointer', marginLeft: '5px' }} 
    />
  );

  const SERIES_COLORS = { cost: '#E53935', revenue: '#2E7D32', roi: '#1E88E5' } as const;

  const renderAnomalyModal = () => {
    if (!showAnomalyModal || !selectedAnomaly) return null;
    const mergedData = mergeSeries(chartData, showPrev ? prevChartData : []);
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
        <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', maxWidth: '1100px', width: '95vw', maxHeight: '80vh', overflow: 'auto', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', borderBottom: '1px solid #e9ecef', paddingBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AlertTriangle size={24} style={{ color: selectedAnomaly.severity === 'critical' ? '#dc3545' : '#ff9800' }} />
              <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600, color: '#2c3e50' }}>Уведомление о кампании</h2>
            </div>
            <button onClick={() => setShowAnomalyModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d', padding: '4px' }}>
              <X size={20} />
            </button>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ fontSize: '16px', color: '#6c757d', marginBottom: '8px', fontWeight: 'normal' }}>
              {selectedAnomaly.severity === 'critical' ? 'Низкая производительность кампании' : 'Предупреждение о кампании'}
            </h3>
            <p style={{ fontSize: '18px', margin: 0, color: '#2c3e50', fontWeight: 500 }}>{selectedAnomaly.description}</p>
          </div>

          {selectedAnomaly.details && Object.keys(selectedAnomaly.details).length > 0 && (
            <div style={{ backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px', marginTop: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', marginRight: '8px' }}>
                  📊 Детали по дням
                </span>
              </div>

              {selectedAnomaly.details.daily_logs && selectedAnomaly.details.daily_logs.current_window && (
                <div style={{ fontSize: '13px', color: '#495057' }}>
                  {selectedAnomaly.details.daily_logs.current_window.map((log: any, index: number) => {
                    const cost = log.cost || 0;
                    const revenue = log.revenue || log.revenue_acti || log.revenue_activation || 0;
                    const roi = log.roi !== undefined ? log.roi : (cost > 0 ? ((revenue - cost) / cost) * 100 : 0);
                    return (
                      <div key={index} style={{ marginBottom: '6px', padding: '8px', backgroundColor: 'white', borderRadius: '4px', border: '1px solid #e9ecef' }}>
                        <strong>- {log.date}:</strong> cost={cost.toFixed(2)}, revenue={revenue.toFixed(2)}, roi={roi.toFixed(2)}%
                      </div>
                    );
                  })}
                </div>
              )}

              <div style={{ marginTop: '20px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '14px', fontWeight: 600, color: '#6c757d', textTransform: 'uppercase', marginRight: '8px' }}>
                    📈 Динамика: {selectedAnomaly?.start_date} — {selectedAnomaly?.end_date}
                  </span>
                </div>

                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  {(['cost', 'revenue', 'roi'] as const).map(key => (
                    <button
                      key={key}
                      onClick={() => toggleSeries(key)}
                      style={{ display: 'flex', alignItems: 'center', gap: 8, border: 'none', borderRadius: 12, padding: '6px 12px', cursor: 'pointer',
                               backgroundColor: seriesVisible[key] ? '#111827' : '#E5E7EB', color: seriesVisible[key] ? '#fff' : '#111827', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                      title={seriesVisible[key] ? 'Скрыть' : 'Показать'}
                    >
                      <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: SERIES_COLORS[key] }} />
                      {key === 'cost' ? 'Costs' : key === 'revenue' ? 'Revenue' : 'ROI (%)'}
                    </button>
                  ))}

                  <button
                    onClick={onTogglePrev}
                    disabled={prevLoading}
                    style={{ display: 'flex', alignItems: 'center', gap: 8, border: 'none', borderRadius: 12, padding: '6px 12px',
                             cursor: prevLoading ? 'progress' : 'pointer', backgroundColor: showPrev ? '#111827' : '#E5E7EB', color: showPrev ? '#fff' : '#111827',
                             boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                    title={showPrev ? 'Скрыть предыдущий период' : 'Показать предыдущий период'}
                  >
                    <span style={{ width: 14, height: 0, borderTop: '2px dashed #6B7280' }} />
                    Previous Period
                  </button>
                </div>

                {prevError && <div style={{ padding: '8px 0', color: '#dc3545' }}>{prevError}</div>}
                {chartLoading && <div style={{ padding: '24px', textAlign: 'center', color: '#6c757d' }}>Загрузка графика…</div>}
                {!chartLoading && chartError && <div style={{ padding: '12px', color: '#dc3545' }}>{chartError}</div>}
                {!chartLoading && !chartError && chartData.length === 0 && <div style={{ padding: '12px', color: '#6c757d' }}>Нет данных.</div>}

                {!chartLoading && !chartError && chartData.length > 0 && (
                  <div style={{ width: '100%', height: 420 }}>
                    <ResponsiveContainer width="100%" height={420}>
                      <LineChart data={mergedData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" tick={{ fontSize: 12 }} interval="preserveStartEnd" />
                        <YAxis yAxisId="left" tickFormatter={(v) => `$${Math.round(v)}`} width={70} />
                        <YAxis yAxisId="right" orientation="right" tickFormatter={(v) => `${Math.round(v)}%`} width={55} />
                        <Tooltip
                          formatter={(val: any, name: any) => String(name).toLowerCase().includes('roi')
                            ? [`${(+val).toFixed(2)}%`, name] : [`$${(+val).toFixed(2)}`, name]}
                          labelFormatter={(label: any) => {
                            const d = new Date(label);
                            return isNaN(d.getTime()) ? String(label) : d.toLocaleDateString();
                          }}
                          contentStyle={{ borderRadius: 8, padding: '8px 10px' }}
                        />
                        <Legend />
                        {seriesVisible.cost && <Line yAxisId="left" type="monotone" dataKey="cost" name="Cost" dot={false} activeDot={{ r: 4 }} strokeWidth={2} stroke={SERIES_COLORS.cost} isAnimationActive={false} />}
                        {seriesVisible.revenue && <Line yAxisId="left" type="monotone" dataKey="revenue" name="Revenue" dot={false} activeDot={{ r: 4 }} strokeWidth={2} stroke={SERIES_COLORS.revenue} isAnimationActive={false} />}
                        {seriesVisible.roi && <Line yAxisId="right" type="monotone" dataKey="roi" name="ROI" dot={false} activeDot={{ r: 4 }} strokeWidth={2} stroke={SERIES_COLORS.roi} isAnimationActive={false} />}
                        {showPrev && seriesVisible.cost && <Line yAxisId="left" type="monotone" dataKey="prev_cost" name="Cost (prev)" dot={false} strokeWidth={2} strokeDasharray="5 5" stroke={SERIES_COLORS.cost} isAnimationActive={false} />}
                        {showPrev && seriesVisible.revenue && <Line yAxisId="left" type="monotone" dataKey="prev_revenue" name="Revenue (prev)" dot={false} strokeWidth={2} strokeDasharray="5 5" stroke={SERIES_COLORS.revenue} isAnimationActive={false} />}
                        {showPrev && seriesVisible.roi && <Line yAxisId="right" type="monotone" dataKey="prev_roi" name="ROI (prev)" dot={false} strokeWidth={2} strokeDasharray="5 5" stroke={SERIES_COLORS.roi} isAnimationActive={false} />}
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // ===================== Колонки P1..P12 (показываем только 12 в UI) =====================
  const renderPeriodColumns = () => {
    if (hideAllPeriods) return [];
    const periods = [];
    for (let i = 1; i <= 12; i++) {
      periods.push(
        <th key={`P${i}`} style={{ padding: '15px 10px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
          P{i}
          {showWithTax && (<span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#2c3e50', marginTop: '2px' }}>After VAT</span>)}
        </th>
      );
      if (showEarlyPredicted) {
        periods.push(
          <th key={`Early P${i}`} style={{ padding: '15px 10px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', backgroundColor: '#f8f9fa', position: 'sticky', top: 0 }}>
            Early P{i}
            <span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#f59e0b', marginTop: '2px' }}>Early Predicted</span>
            {showWithTax && (<span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#2c3e50', marginTop: '1px' }}>After VAT</span>)}
          </th>
        );
      }
    }
    return periods;
  };

  const renderPeriodValues = (item: OrderData, isGrandTotalRow: boolean = false) => {
    if (hideAllPeriods) return [];
    const periodValues = [];
    const isAggregatedData = item.country === 'All' || item.campaign === 'Total' || item.campaign === item.country;
    const enrichedItem: OrderData = isAggregatedData ? item : enrichOrderDataWithEarlyPredicted(item);
    for (let i = 1; i <= 12; i++) {
      const periodKey = `revenue_p${i}` as keyof OrderData;
      const value = enrichedItem[periodKey];
      const adjustedValue = isAggregatedData ? getNumericValue(value) : getAdjustedRevenue(getNumericValue(value), enrichedItem.country);
      periodValues.push(
        <td key={`p${i}`} style={{ padding: '15px 10px', textAlign: 'right', color: 'black',
          borderRight: isGrandTotalRow ? '1px solid rgba(255,255,255,0.3)' : '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
          {adjustedValue.toFixed(2)}
        </td>
      );
      if (showEarlyPredicted) {
        const earlyPredictedKey = `early_predicted_revenue_p${i}` as keyof OrderData;
        const earlyPredictedValue = isAggregatedData ? getNumericValue(enrichedItem[earlyPredictedKey]) : getNumericValue(enrichedItem[earlyPredictedKey]);
        const adjustedEarlyPredictedValue = isAggregatedData ? earlyPredictedValue : getAdjustedRevenue(earlyPredictedValue, enrichedItem.country);
        periodValues.push(
          <td key={`early_p${i}`} style={{ padding: '15px 10px', textAlign: 'right', color: 'black',
            borderRight: isGrandTotalRow ? '1px solid rgba(255,255,255,0.3)' : '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
            {adjustedEarlyPredictedValue.toFixed(2)}
          </td>
        );
      }
    }
    return periodValues;
  };

  const SortableHeaderCell: React.FC<{
    column: string;
    title: string;
    vatAdjusted?: boolean;
    earlyPredicted?: boolean;
    style?: React.CSSProperties;
  }> = ({ column, title, vatAdjusted = false, earlyPredicted = false, style = {} }) => (
    <th 
      onClick={() => setSortConfig(prev => {
        if (prev.key !== column) return { key: column, direction: 'desc' };
        switch (prev.direction) {
          case 'none': return { key: column, direction: 'desc' };
          case 'desc': return { key: column, direction: 'asc' };
          case 'asc': return { key: column, direction: 'none' };
          default: return { key: column, direction: 'desc' };
        }
      })}
      style={{ 
        padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px',
        textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6',
        cursor: 'pointer', position: 'sticky', top: 0, backgroundColor: '#f8f9fa', transition: 'background-color 0.2s ease', ...style 
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '5px' }}>
        {title}
        {sortConfig.key !== column ? <ArrowUpDown size={16} className="sort-icon" /> :
          sortConfig.direction === 'desc' ? <ArrowDown size={16} className="sort-icon" /> :
          sortConfig.direction === 'asc' ? <ArrowUp size={16} className="sort-icon" /> :
          <ArrowUpDown size={16} className="sort-icon" />}
      </div>
      {vatAdjusted && showWithTax && (<span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#2c3e50', marginTop: '2px' }}>After VAT</span>)}
      {earlyPredicted && (<span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#f59e0b', marginTop: '2px' }}>Early Predicted</span>)}
    </th>
  );

  // ===================== Агрегация: Date -> (Country?) -> (Campaign?) =====================
  const aggregateData = (): AggregatedData => {
    if (viewMode === 'daily') {
      const aggregated: AggregatedData = {};

      Object.entries(ordersData).forEach(([date, byCountry]) => {
        const dayItems: OrderData[] = [];
        const countriesMap: { [country: string]: OrderData[] } = {};

        Object.entries(byCountry as Record<string, OrderData[]>).forEach(([country, items]) => {
          items.forEach(item => {
            const countryMatch  = selectedCountries.length === 0 || selectedCountries.includes(item.country);
            const campaignMatch = selectedCampaigns.length === 0 || selectedCampaigns.includes(item.campaign || '---');
            const platformMatch = selectedPlatforms.length === 0 || selectedPlatforms.includes(item.platform || '---');
            if (countryMatch && campaignMatch && platformMatch) {
              dayItems.push(item);
              if (!countriesMap[country]) countriesMap[country] = [];
              countriesMap[country].push(item);
            }
          });
        });

        if (dayItems.length === 0) return;

        // 1) дата
        const dayAgg = aggregateItemsCorrectly(dayItems, 'All', date);
        dayAgg.campaign_id = undefined;
        dayAgg.platform = '---';
        aggregated[date] = dayAgg;

        if (showCountries) {
          // 2) страны под датой
          Object.entries(countriesMap).forEach(([country, items]) => {
            const countryAgg = aggregateItemsCorrectly(items, country, country);
            countryAgg.campaign_id = undefined;
            countryAgg.platform = '---';
            aggregated[`${date}::${country}`] = countryAgg;

            if (showCampaigns) {
              // 3) кампании под страной
              const byCampaign: { [campaign: string]: OrderData[] } = {};
              items.forEach(it => {
                const camp = it.campaign || '---';
                if (!byCampaign[camp]) byCampaign[camp] = [];
                byCampaign[camp].push(it);
              });
              Object.entries(byCampaign).forEach(([campaign, citems]) => {
                aggregated[`${date}::${country}::${campaign}`] = aggregateItemsCorrectly(citems, country, campaign);
              });
            }
          });
        } else if (showCampaigns) {
          // 2-бис) только кампании под датой (агрегат по всем странам дня)
          const dayCampaignMap: { [campaign: string]: OrderData[] } = {};
          dayItems.forEach(it => {
            const camp = it.campaign || '---';
            if (!dayCampaignMap[camp]) dayCampaignMap[camp] = [];
            dayCampaignMap[camp].push(it);
          });
          Object.entries(dayCampaignMap).forEach(([campaign, citems]) => {
            const campAgg = aggregateItemsCorrectly(citems, 'All', campaign);
            aggregated[`${date}::${campaign}`] = campAgg;
          });
        }
      });

      return aggregated;
    }

    // НЕ daily — старая логика
    const aggregated: AggregatedData = {};
    const filteredItems = getFilteredItems();

    if (showCountries && !showCampaigns) {
      const countryGroups: { [country: string]: OrderData[] } = {};
      filteredItems.forEach(item => {
        if (!countryGroups[item.country]) countryGroups[item.country] = [];
        countryGroups[item.country].push(item);
      });
      Object.entries(countryGroups).forEach(([country, items]) => {
        aggregated[country] = aggregateItemsCorrectly(items, country);
      });
    } else if (!showCountries && showCampaigns) {
      const campaignGroups: { [campaign: string]: OrderData[] } = {};
      filteredItems.forEach(item => {
        const campaign = item.campaign || '---';
        if (!campaignGroups[campaign]) campaignGroups[campaign] = [];
        campaignGroups[campaign].push(item);
      });
      Object.entries(campaignGroups).forEach(([campaign, items]) => {
        aggregated[campaign] = aggregateItemsCorrectly(items, 'All', campaign);
      });
    } else if (showCountries && showCampaigns) {
      const countryGroups: { [country: string]: OrderData[] } = {};
      filteredItems.forEach(item => {
        if (!countryGroups[item.country]) countryGroups[item.country] = [];
        countryGroups[item.country].push(item);
      });
      Object.entries(countryGroups).forEach(([country, items]) => {
        aggregated[country] = aggregateItemsCorrectly(items, country);
        const campaignGroups: { [campaign: string]: OrderData[] } = {};
        items.forEach(item => {
          const campaign = item.campaign || '---';
          if (!campaignGroups[campaign]) campaignGroups[campaign] = [];
          campaignGroups[campaign].push(item);
        });
        Object.entries(campaignGroups).forEach(([campaign, campaignItems]) => {
          aggregated[`${country}::${campaign}`] = aggregateItemsCorrectly(campaignItems, country, campaign);
        });
      });
    } else {
      aggregated['Total'] = aggregateItemsCorrectly(filteredItems, 'All', 'Total');
    }
    return aggregated;
  };

  // ===================== Сортировка / порядок рендеринга =====================
  const aggregatedData = aggregateData();

  // Grand Total — сумма за все выбранные дни/фильтры
  const grandTotalEntry = ((): [string, OrderData] | null => {
    const filteredItems = getFilteredItems();
    if (filteredItems.length === 0) return null;
    const grandTotal = aggregateItemsCorrectly(filteredItems, 'All', 'Total');
    return ['Total', grandTotal];
  })();

  let entriesToRender: [string, OrderData][] = Object.entries(aggregatedData);

  if (viewMode === 'daily') {
    const dateKeys = Array.from(new Set(
      Object.keys(aggregatedData)
        .map(k => k.split('::')[0])
        .filter(k => k !== 'Total')
    )).sort();

    const ordered: [string, OrderData][] = [];

    dateKeys.forEach(dateKey => {
      // 1) дата
      if (aggregatedData[dateKey]) ordered.push([dateKey, aggregatedData[dateKey]]);

      if (showCountries && showCampaigns) {
        // Date -> Countries -> Campaigns
        const countryKeys = Object.keys(aggregatedData)
          .filter(k => k.startsWith(`${dateKey}::`) && k.split('::').length === 2);

        if (sortConfig.direction !== 'none' && sortConfig.key) {
          countryKeys.sort((a, b) => {
            const va = getColumnValue(aggregatedData[a], sortConfig.key);
            const vb = getColumnValue(aggregatedData[b], sortConfig.key);
            return sortConfig.direction === 'desc' ? (vb - va) : (va - vb);
          });
        } else {
          countryKeys.sort();
        }

        countryKeys.forEach(countryKey => {
          ordered.push([countryKey, aggregatedData[countryKey]]);
          const campaignKeys = Object.keys(aggregatedData)
            .filter(k => k.startsWith(`${countryKey}::`) && k.split('::').length === 3);

          if (sortConfig.direction !== 'none' && sortConfig.key) {
            campaignKeys.sort((a, b) => {
              const va = getColumnValue(aggregatedData[a], sortConfig.key);
              const vb = getColumnValue(aggregatedData[b], sortConfig.key);
              return sortConfig.direction === 'desc' ? (vb - va) : (va - vb);
            });
          } else {
            campaignKeys.sort();
          }

          campaignKeys.forEach(cKey => ordered.push([cKey, aggregatedData[cKey]]));
        });
      } else if (showCountries && !showCampaigns) {
        // Date -> Countries
        let countryKeys = Object.keys(aggregatedData)
          .filter(k => k.startsWith(`${dateKey}::`) && k.split('::').length === 2);

        if (sortConfig.direction !== 'none' && sortConfig.key) {
          countryKeys.sort((a, b) => {
            const va = getColumnValue(aggregatedData[a], sortConfig.key);
            const vb = getColumnValue(aggregatedData[b], sortConfig.key);
            return sortConfig.direction === 'desc' ? (vb - va) : (va - vb);
          });
        } else {
          countryKeys = countryKeys.sort();
        }
        countryKeys.forEach(k => ordered.push([k, aggregatedData[k]]));
      } else if (!showCountries && showCampaigns) {
        // Date -> Campaigns (двухуровневые ключи вида Дата::Кампания)
        let campaignKeys2 = Object.keys(aggregatedData)
          .filter(k => k.startsWith(`${dateKey}::`) && k.split('::').length === 2);

        if (sortConfig.direction !== 'none' && sortConfig.key) {
          campaignKeys2.sort((a, b) => {
            const va = getColumnValue(aggregatedData[a], sortConfig.key);
            const vb = getColumnValue(aggregatedData[b], sortConfig.key);
            return sortConfig.direction === 'desc' ? (vb - va) : (va - vb);
          });
        } else {
          campaignKeys2 = campaignKeys2.sort();
        }
        campaignKeys2.forEach(k => ordered.push([k, aggregatedData[k]]));
      } else {
        // только дата
      }
    });

    entriesToRender = ordered;
  } else {
    // плоский порядок вне daily
    if (distributeUnknowns || distributeDirect) {
      const distributedData = distribute_campaigns_advanced(
        aggregatedData,
        distributeUnknowns,
        distributeDirect,
        !showCountries
      );
      entriesToRender = Object.entries(distributedData);
    }
    if (sortConfig.direction !== 'none' && sortConfig.key) {
      entriesToRender.sort(([, a], [, b]) => {
        const va = getColumnValue(a, sortConfig.key);
        const vb = getColumnValue(b, sortConfig.key);
        return sortConfig.direction === 'desc' ? (vb - va) : (va - vb);
      });
    }
  }

  if (grandTotalEntry) {
    entriesToRender.unshift(grandTotalEntry);
  }

  const calculateColSpan = (): number => {
    let baseColumns = 15;
    if (!hideAllPeriods) {
      baseColumns += 12;
      if (showEarlyPredicted) baseColumns += 12;
    }
    if (showEarlyPredicted) baseColumns += 3;
    return baseColumns;
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <Loader2 size={48} style={{ animation: 'spin 1s linear infinite', color: '#3498db' }} />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 10px rgba(0,0,0,0.06)', margin: '20px 30px', padding: '20px', textAlign: 'center', color: '#dc3545' }}>
        {error}
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 10px rgba(0,0,0,0.06)', margin: '20px 30px', overflow: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0', fontSize: '14px' }}>
        <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#f8f9fa', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
            <th style={{ padding: '15px 20px', textAlign: 'left', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              {viewMode === 'daily'
                ? (showCountries && showCampaigns ? 'Date / Country / Campaign'
                  : showCountries ? 'Date / Country'
                  : showCampaigns ? 'Date / Campaign'
                  : 'Date')
                : (showCountries && showCampaigns ? 'Country / Campaign'
                  : showCountries ? 'Country'
                  : showCampaigns ? 'Campaign'
                  : 'Total')}
              {anomaliesLoading && <span style={{ color: '#007bff', fontSize: '10px', marginLeft: '5px' }}>(Loading anomalies...)</span>}
              <span style={{ display: 'block', fontSize: '11px', color: '#6c757d', fontWeight: 'normal', textTransform: 'none' }}>
                {dateFrom} - {dateTo}
              </span>
            </th>
            <th style={{ padding: '15px 15px', textAlign: 'left', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              Platform
            </th>
            <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              Revenue Activation Count
            </th>
            <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              Revenue Activation Purchase Count
            </th>
            <SortableHeaderCell column="revenue_activation" title="Revenue Activation" vatAdjusted />
            <SortableHeaderCell column="revenue_activation_purchase" title="Revenue Activation Purchase" vatAdjusted />
            {renderPeriodColumns()}
            <SortableHeaderCell column="costs" title="Cost" />
            <SortableHeaderCell column="total_revenue" title="Total Revenue" vatAdjusted />
            <SortableHeaderCell column="profit" title="Profit" style={{ backgroundColor: '#f8f9fa' }} />
            <SortableHeaderCell column="roi" title="ROI (%)" />
            <SortableHeaderCell column="predicted_roi" title="Predicted ROI (%)" />
            <SortableHeaderCell column="total_predicted_revenue" title="Total Predicted Revenue" vatAdjusted />
            {showEarlyPredicted && (
              <>
                <SortableHeaderCell column="early_predicted_roi" title="Early Predicted ROI (%)" earlyPredicted />
                <SortableHeaderCell column="total_early_predicted_revenue" title="Total Early Predicted Revenue" vatAdjusted earlyPredicted />
                <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', backgroundColor: '#f8f9fa', position: 'sticky', top: 0 }}>
                  Early Predicted LTV
                  <span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#f59e0b', marginTop: '2px' }}>Early Predicted</span>
                  {showWithTax && (<span style={{ fontSize: '10px', display: 'block', fontWeight: 'normal', color: '#2c3e50', marginTop: '1px' }}>After VAT</span>)}
                </th>
              </>
            )}
            <SortableHeaderCell column="cpa_cost_per_action" title="CPA" />
            <SortableHeaderCell column="cpu_cost_per_user" title="CPU" />
            <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              LTV
            </th>
            <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderRight: '1px solid #e9ecef', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              Predicted LTV
            </th>
            <th style={{ padding: '15px 15px', textAlign: 'right', fontWeight: 600, color: '#6c757d', fontSize: '13px', textTransform: 'uppercase', borderBottom: '2px solid #dee2e6', position: 'sticky', top: 0, backgroundColor: '#f8f9fa' }}>
              ARPPU
            </th>
          </tr>
        </thead>
        <tbody>
          {entriesToRender.map(([key, item]) => {
            const parts = key.split('::');
            const isGrandTotalRow = key === 'Total';

            let isDateRow = false;
            let isCountryRow = false;
            let isCampaignRow = false;

            if (viewMode === 'daily') {
              if (parts.length === 1 && key !== 'Total') {
                isDateRow = true;
              } else if (parts.length === 2) {
                if (showCountries && showCampaigns) {
                  isCountryRow = true;
                } else if (showCountries && !showCampaigns) {
                  isCountryRow = true;
                } else if (!showCountries && showCampaigns) {
                  isCampaignRow = true; // Дата::Кампания
                }
              } else if (parts.length === 3) {
                isCampaignRow = true; // Дата::Страна::Кампания
              }
            } else {
              // НЕ daily
              if (showCountries && showCampaigns) {
                // Country (level 1) and Country::Campaign (level 2)
                if (parts.length === 1 && key !== 'Total') isCountryRow = true;
                if (parts.length === 2) isCampaignRow = true;
              } else if (showCountries && !showCampaigns) {
                if (parts.length === 1 && key !== 'Total') isCountryRow = true;
              } else if (!showCountries && showCampaigns) {
                if (parts.length === 1 && key !== 'Total') isCampaignRow = true; // топ-уровневые кампании
              } else {
                // только Total
              }
            }

            let displayName = key;
            if (viewMode === 'daily') {
              if (isCountryRow) displayName = parts[1];
              else if (isCampaignRow) displayName = parts[parts.length - 1];
              else if (isDateRow) displayName = parts[0];
            } else {
              if (isCampaignRow) displayName = parts.length === 2 ? parts[1] : parts[0];
              else if (isCountryRow) displayName = parts[0];
            }

            const leftPadding =
              isGrandTotalRow ? '20px' :
              isDateRow ? '20px' :
              isCountryRow ? '40px' : '60px';

            const campaignHasAnomalies = isCampaignRow && hasAnomalies(item);
            const campaignAnomalies = isCampaignRow ? getAnomaliesForCampaign(item) : [];
            const mostSevereAnomaly = isCampaignRow ? getMostSevereAnomaly(campaignAnomalies) : null;

            const profit = calculateTotalRevenue(item) - getNumericValue(item.costs);
            const roi = calculateROI(item);
            const predictedRoi = calculatePredictedROI(item);
            const earlyPredictedRoi = calculateEarlyPredictedROI(item);
            const earlyPredictedLtv = calculateEarlyPredictedLTV(item);
            const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);

            return (
              <tr 
                key={key}
                style={{
                  borderBottom: '1px solid #e9ecef',
                  transition: 'background-color 0.2s ease',
                  backgroundColor: isGrandTotalRow ? getRowBackgroundColor(item, true) : getRowBackgroundColor(item),
                  color: isGrandTotalRow ? 'black' : 'inherit',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = getRowHoverColor(item, isGrandTotalRow); }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = isGrandTotalRow ? getRowBackgroundColor(item, true) : getRowBackgroundColor(item); }}
              >
                <td style={{
                  padding: '15px 20px',
                  fontWeight: isGrandTotalRow || isDateRow || isCountryRow ? 600 : 'normal',
                  borderRight: '1px solid #e9ecef',
                  borderBottom: '1px solid #e9ecef',
                  paddingLeft: leftPadding
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span
                      style={{ cursor: 'pointer', textDecoration: 'none' }}
                      onClick={() => handleCampaignClick(item)}
                    >
                      {displayName}
                    </span>

                    {/* 1) Статус-бейдж (показываем как раньше, текст ровно из ответа) */}
                    {!isCountryRow && !isGrandTotalRow && renderFbStatusBadge(getFbStatusForItem(item))}

                    {/* 2) Бейдж-действие "Начать/Остановить" — только для строк кампаний с числовым campaign_id */}
                    {(() => {
                      const currentStatus = getFbStatusForItem(item);           // текущий текст статуса, как пришёл
                      const key = getUpdateKey(item);
                      const loading = !!fbUpdating[key];
                      const canAct = isActionable(item, isCountryRow, isGrandTotalRow);
                      if (!canAct) return null;

                      const next = getNextStatus(currentStatus);
                      const label = getActionLabel(next);

                      return (
                        <span
                          role="button"
                          onClick={(e) => { e.stopPropagation(); if (!loading) toggleFbStatus(item, currentStatus); }}
                          style={getActionBadgeStyle(next, loading)}
                          title={label}
                        >
                          {loading ? (
                            <>
                              <Loader2 size={14} style={{ animation: 'spin 1s linear infinite' }} />
                              LOADING…
                            </>
                          ) : (
                            label
                          )}
                        </span>
                      );
                    })()}

                    {/* Иконка аномалии — как было */}
                    {campaignHasAnomalies && mostSevereAnomaly && (
                      <span onClick={() => handleAnomalyClick(item)}>
                        {getAnomalyIcon(mostSevereAnomaly.severity)}
                      </span>
                    )}
                  </div>
                </td>

                <td style={{ padding: '15px 15px', textAlign: 'left', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {isCampaignRow ? (item.platform || '---') : ''}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {(getNumericValue(item.revenue_activation_count)).toLocaleString()}
                </td>
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {(getNumericValue(item.revenue_activation_purchase_count)).toLocaleString()}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {getAdjustedRevenue(getNumericValue(item.revenue_activation_original), item.country).toFixed(2)}
                </td>
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {getAdjustedRevenue(getNumericValue(item.revenue_activation_purchase), item.country).toFixed(2)}
                </td>

                {renderPeriodValues(item, isGrandTotalRow)}
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {getNumericValue(item.costs).toFixed(2)}
                </td>
                
                <td style={{ padding: '15px 15px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', fontWeight: 600 }}>
                  {calculateTotalRevenue(item).toFixed(2)}
                </td>

                <td style={{ padding: '15px 15px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', fontWeight: 600, color: getValueColor(profit) }}>
                  {profit.toFixed(2)}
                </td>

                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', color: getValueColor(roi) }}>
                  {roi.toFixed(2)}%
                </td>

                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', color: getValueColor(predictedRoi) }}>
                  {predictedRoi.toFixed(2)}%
                </td>
                
                <td style={{ padding: '15px 15px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', fontWeight: 600 }}>
                  {calculateTotalPredictedRevenue(item).toFixed(2)}
                </td>

                {showEarlyPredicted && (
                  <>
                    <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', color: 'black' }}>
                      {earlyPredictedRoi.toFixed(2)}%
                    </td>
                    <td style={{ padding: '15px 15px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', fontWeight: 600, color: 'black' }}>
                      {earlyPredictedRevenue.toFixed(2)}
                    </td>
                    <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef', color: 'black' }}>
                      {earlyPredictedLtv.toFixed(2)}
                    </td>
                  </>
                )}
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {calculateCPA(item).toFixed(2)}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {calculateCPU(item).toFixed(2)}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {calculateLTV(item).toFixed(2)}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderRight: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                  {calculatePredictedLTV(item).toFixed(2)}
                </td>
                
                <td style={{ padding: '15px 10px', textAlign: 'right', borderBottom: '1px solid #e9ecef' }}>
                  {calculateARPPU(item).toFixed(2)}
                </td>
              </tr>
            );
          })}
          
          {entriesToRender.length === 0 && (
            <tr>
              <td colSpan={calculateColSpan()} style={{ padding: '30px 20px', textAlign: 'center', color: '#6c757d' }}>
                No data available for the selected filters
              </td>
            </tr>
          )}
        </tbody>
      </table>
      
      {renderAnomalyModal()}
    </div>
  );
};

export default TotalsComponent;